export default "__VITE_ASSET__Dt4xAso2__"